import NotFound from '../NotFound/NotFound';
import React, { Fragment } from 'react';
import { Box, Button } from '@mui/material';
import { toBase64 } from '../../utils';
import BottomSheetOrDialog from '../../components/BottomSheetOrDialog/BottomSheetOrDialog';
import { useState } from 'react';
import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';
import NativeOrWeb from '../../utils/native';
import { useEffect } from 'react';
const MULTIPRO_URL = process.env.MULTIPRO_URL;

const ConsultaionReservation = props => {
  const { history, intl } = props;
  const { showPadding } = props;
  const userDetails = props.userDetails;
  const [openLoginDialog, setOpenLoginDialog] = useState(!userDetails?._id);
  // console.log('userDetails', userDetails);
  const getIFrameSrc = () => {
    const { email, name, phoneNumber, language } = userDetails;
    const params = {};
    if (email) {
      params.e = toBase64(email);
      params.l = 'e';
    }
    if (name) {
      params.n = toBase64(name);
    }
    if (phoneNumber) {
      params.t = toBase64(phoneNumber);
    }
    if (language) {
      params.lang = toBase64(language);
    }
    if (userDetails?._id) {
      params.bookingType = toBase64('1ON1');
      params.u = toBase64(userDetails._id);
    } else {
      params.bookingType = toBase64('DEMO');
    }
    return MULTIPRO_URL + '/reservation?' + new URLSearchParams(params).toString();
  };

  useEffect(() => {
    const isNative = NativeOrWeb.isNativePlatform();
    if (isNative && !userDetails._id) {
      history.push('/login', { from: window.location.pathname });
    }
  }, []);

  if (!MULTIPRO_URL) {
    return <NotFound />;
  }
  const frameSrc = getIFrameSrc();

  return (
    <Fragment>
      <BottomSheetOrDialog
        open={openLoginDialog}
        onClose={() => {
          setOpenLoginDialog(false);
        }}
        header={intl.formatMessage({ id: 'reservation-user-alert-title' })}
        content={
          <Fragment>
            <Box>{intl.formatMessage({ id: 'reservation-user-alert-content' })}</Box>
          </Fragment>
        }
        BottomSheetParams={{
          hideCloseButton: true
        }}
        DialogParams={{
          hideCloseButton: true
        }}
        actions={[
          <Button
            variant="contained"
            color="primary"
            style={{ marginRight: 10 }}
            onClick={() => {
              setOpenLoginDialog(false);
            }}
          >
            {intl.formatMessage({ id: 'reservation-user-alert-cta-continue-as-guest' })}
          </Button>,
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setOpenLoginDialog(false);
              history.push('/login', { from: window.location.pathname });
            }}
          >
            {intl.formatMessage({ id: 'reservation-user-alert-cta-login' })}
          </Button>
        ]}
      />

      <iframe
        title="Consultaion Booking"
        src={frameSrc}
        style={{
          width: showPadding ? 'calc(100% - 60px)' : '100%',
          height: '100%',
          position: 'fixed',
          border: 'none',
          paddingTop: props.userDetails._id ? 45 : undefined
        }}
      />
    </Fragment>
  );
};

export default injectIntl(withRouter(ConsultaionReservation));
